export const PreventRouteEnum = {
  Orders: 'orders',
  Order: 'order',
  Transactions: 'transactions',
  Transaction: 'transaction',
  Notifications: 'notifications',
  Notification: 'notification',
};

